export const formatFromAccount = (acctNum: string, amountAvailable: number, title?: string) => {
  const amount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amountAvailable)
  return `${acctNum} ${title && `(${title}) - ${amount}`}`
}
